'use client';
import { ScrollToTop } from '../homepage/scroll-to-top';
import { version as eliadminCoreVersion } from '@eliadmin/core/package.json';

declare global {
  interface Window {
    __ELIADMIN_CORE_VERSION_LOGGED?: boolean;
  }
}

// Log once on the client (avoid duplicates in dev Fast Refresh)
if (typeof window !== 'undefined' && !window.__ELIADMIN_CORE_VERSION_LOGGED) {
  // eslint-disable-next-line no-console
  console.log('@eliadmin/core version:', eliadminCoreVersion);
  window.__ELIADMIN_CORE_VERSION_LOGGED = true;
}

export function BodyClientOverride() {
  return (
    <>
      <ScrollToTop />
    </>
  );
}
